import axios from 'axios';
import common from '../libs/common';
// import notice from './notice';
const lang = document.querySelector('.lang-dropdown');
if (lang) {
  const langPanel = lang.querySelector('.lang-select');
  const langItems = lang.querySelectorAll('.lang-item');
  common.hover(lang, () => {
    langPanel.style.height = '200px';
  }, () => {
    langPanel.style.height = '';
  });
  function replaceParamVal(paramName, replaceWith) {
    let oldUrl = window.location.href.toString();
    let replaceStr = eval(`/(${ paramName}=)([^&]*)/gi`);
    return oldUrl.replace(replaceStr, `${paramName}=${replaceWith}`);
  }
  function changeLanguage(flag) {
    let locale = flag || 'zh_cn';
    let data = {
      locale,
    };
    axios.create({
      timeout: 5000,
      headers: { 'content-type': 'application/json;charset=utf-8' },
    });
    let promise = axios.get('/api/v1/changeLanguage', { params: data });
    promise.then((res) => {
      window.location.replace(replaceParamVal('languagetype', locale));
    });
  }
  langItems.forEach((elem) => {
    elem.addEventListener('click', function () {
      let { lang } = this.dataset;
      changeLanguage(lang);
      return false;
    });
  });
}
